import { EmailService } from 'src/app/services/email/email.service';
import { EmpresaService } from './../../../services/empresa.service';
import { Empresa } from './../../../models/empresa';
import { UsuarioService } from './../../../services/usuario/usuario.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { group } from '@angular/animations';

import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';



@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  formausuario: FormGroup;
  mostrarAvisoPrivacidad = false;
  avisoPrivacidad = '';
  avisoPrivacidadCargado = false;
  avisoLeidoHastaFinal = false;
  avisoAceptado = false;
  guardandoRegistro = false;
  readonly versionAvisoPrivacidad = '2026-08-25';


  constructor(
    public router: Router,
    public empresaService: EmpresaService,
    public emailService: EmailService,
    private http: HttpClient) { }

  sonIguales( campo1: string, campo2: string) {
    return (group: FormGroup) => {

      const pass1 = group.controls[campo1].value;
      const pass2 = group.controls[campo2].value;

      if ( pass1 === pass2 ) {
        return null;
      }

      return {
        sonIguales: true
      };
    };
  }



  // ngOnInit() {

  //   this.formausuario = new FormGroup ({
  //     nombreEmpresa: new FormControl( 'EL FOR MX' , Validators.required ),
  //     nombrecliente: new FormControl( 'NONMBRE CLIENTE 1' , Validators.required ),
  //     apellido: new FormControl( 'APELLIDO' , Validators.required ),
  //     email: new FormControl( 'FORO@GMAIL.COM' , [Validators.required, Validators.email] ),
  //     emailpersonal: new FormControl( 'EMAILPER@HOTMAIL.COM' , [Validators.required, Validators.email] ),
  //     telefono: new FormControl( '6645051252'),
  //     celular: new FormControl( '6645125125'),
  //     direccionweb: new FormControl( 'elforo.com'),
  //     direccion: new FormControl( 'america 8'),
  //     ciudad: new FormControl( 'tijuana'),
  //     estado: new FormControl( 'bc'),
  //     pais: new FormControl( 'mx'),
  //     zipcode: new FormControl( '22100' , Validators.required ),
  //     password: new FormControl( '123' , Validators.required),
  //     password2: new FormControl( '123' , Validators.required),
  //   }, { validators: this.sonIguales ( 'password', 'password2')});
  // }


  ngOnInit() {

    this.formausuario = new FormGroup ({
      nombreEmpresa: new FormControl( '' , Validators.required ),
      nombrecliente: new FormControl( '' , Validators.required ),
      apellido: new FormControl( '' , Validators.required ),
      alias: new FormControl( '' , Validators.required ),
      email: new FormControl( '' , [Validators.required, Validators.email] ),
      emailpersonal: new FormControl( '' , [Validators.required, Validators.email] ),
      telefono: new FormControl( ''),
      celular: new FormControl( ''),
      direccionweb: new FormControl( ''),
      direccion: new FormControl( ''),
      ciudad: new FormControl( ''),
      estado: new FormControl( ''),
      pais: new FormControl( ''),
      zipcode: new FormControl( '' , Validators.required ),
      password: new FormControl( '' , Validators.required),
      password2: new FormControl( '' , Validators.required),
    }, { validators: this.sonIguales ( 'password', 'password2')});

    this.cargarAvisoPrivacidad();
  }


  cargarAvisoPrivacidad() {
    this.http.get('assets/aviso-privacidad.txt', { responseType: 'text' })
      .subscribe(
        texto => {
          this.avisoPrivacidad = texto;
          this.avisoPrivacidadCargado = true;
        },
        () => {
          this.avisoPrivacidad = 'The Privacy Notice could not be loaded. Please try again.';
          this.avisoPrivacidadCargado = false;
        }
      );
  }


  registrarUsuario(){

    if ( this.formausuario.invalid ) {
      this.formausuario.markAllAsTouched();
      return;
    }

    if (!this.avisoPrivacidadCargado) {
      alert('The Privacy Notice could not be loaded. Please try again.');
      return;
    }

    this.avisoLeidoHastaFinal = false;
    this.avisoAceptado = false;
    this.mostrarAvisoPrivacidad = true;
  }


  detectarFinalAviso(evento: Event) {
    const contenedor = evento.target as HTMLElement;
    const tolerancia = 2;
    const llegoAlFinal = contenedor.scrollTop + contenedor.clientHeight >= contenedor.scrollHeight - tolerancia;

    if (llegoAlFinal) {
      this.avisoLeidoHastaFinal = true;
    }
  }


  cancelarAvisoPrivacidad() {
    if (this.guardandoRegistro) {
      return;
    }

    this.mostrarAvisoPrivacidad = false;
    this.avisoAceptado = false;
    this.avisoLeidoHastaFinal = false;
  }


  aceptarAvisoYRegistrar() {
    if (!this.avisoLeidoHastaFinal || !this.avisoAceptado || this.guardandoRegistro) {
      return;
    }

    this.guardandoRegistro = true;

    const empresa = new Empresa(
      this.formausuario.value.nombreEmpresa,
      this.formausuario.value.nombrecliente,
      this.formausuario.value.apellido,
      this.formausuario.value.email,
      this.formausuario.value.telefono,
      this.formausuario.value.celular,
      this.formausuario.value.direccionweb,
      this.formausuario.value.direccion,
      this.formausuario.value.ciudad,
      this.formausuario.value.estado,
      this.formausuario.value.pais,
      this.formausuario.value.zipcode,
      this.formausuario.value.password,
      this.formausuario.value.emailpersonal,
      null,
      this.formausuario.value.alias,
      null,
      null,
      null,
      true,
      this.versionAvisoPrivacidad,
      new Date()


    );

    console.log ('valores :', empresa);

    this.empresaService.crearempresaformulario( empresa )
    .subscribe ( resp => {
      this.guardandoRegistro = false;
      this.mostrarAvisoPrivacidad = false;
      this.router.navigate(['login/login']);
      this.enviaemail();
    // console.log ('registrado');
    }, () => {
      this.guardandoRegistro = false;
    });



  }


  enviaemail() {
    // const nombreArchivocompleto = this.nombreArchivoPDF;
     const subJet = 'Un nuevo landing : " + this.formausuario.value.nombreEmpresa  + " se ha dado de alta por primera vez' ;

    // const direccionemail = this.txtemail;
  //   const filepdf = nombreArchivocompleto;

   //  this.nombreArchivoPDF = filepdf;
     this.emailService.sendEmailTuripes(subJet)
            .subscribe(
              licen => {
                 // alert ('listo');
                // this.botonFinalizadeshabilitado = false;
               },

              );
       }


}
